import { NgModule } from '@angular/core';
import { FormatPhoneNumberOrExtensionPipe } from './format-phone-number-or-extension.pipe';

@NgModule({
   declarations: [FormatPhoneNumberOrExtensionPipe],
   exports: [FormatPhoneNumberOrExtensionPipe],
})
export class FormatPhoneNumberorExtensionPipeModule {}
